export default __webpack_public_path__ + "static/media/payment-executed.7633ff48.svg";